import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { debounce, pick, get } from 'lodash';

import ShareInfoNumberOfSlots from '../../components/commit-form/share-info.slots';
import ShareInfoSPP from '../../components/commit-form/share-info.spp';
import ShareInfoEvenSplitLocked from '../../components/commit-form/share-info.even-split.locked';
import ShareInfoLocked from '../../components/commit-form/share-info.locked';

import {
  projectPurchase,

  DASHBOARD_COMMIT,
  COMMIT_NAMESPACE,
} from '../../actions';
import {
  getMemberConsumerFieldSchemas,
  getCurrentUserMembership,
} from '../../selectors/purchase-selector';
import Purchase from '../../lib/purchase';
import { Money } from '../../lib/money';

class ShareInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.debouncedProjectPurchase = debounce(this.props.actions.projectPurchase, 200);
    this.projectPurchase = this.projectPurchase.bind(this);
    this.onSlotsChange = this.onSlotsChange.bind(this);
  }

  onSlotsChange(claimedSlots, allowedShareAmount) {
    this.projectPurchase(claimedSlots, allowedShareAmount);
    this.props.onChange(claimedSlots, allowedShareAmount);
  }

  showingEvenSplitLocked() {
    if (this.props.editing) return false;

    const { group: { splitType } } = this.props.purchase;
    return !this.showingFixedPerPerson() && Purchase.isEvenSplit(splitType);
  }

  showingShareInfoLocked() {
    if (this.props.editing) return false;
    return this.props.memberConsumerFieldSchemas.length > 0;
  }

  showingFixedPerPerson() {
    const { group: { splitType } } = this.props.purchase;
    return Purchase.isFixedPerPerson(splitType);
  }

  showingSpecifiedPerPerson() {
    const { purchase } = this.props;
    return Purchase.isSpecifiedPerPerson(purchase.group.splitType);
  }

  projectPurchase(claimedSlots, allowedShareAmount) {
    const purchase = pick(this.props.purchase, ['id', 'group']);
    purchase.memberships = [
      {
        id: this.props.currentMembershipId,
        claimedSlots,
        allowedShareAmount,
      },
    ];

    this.debouncedProjectPurchase(purchase, COMMIT_NAMESPACE);
  }

  render() {
    const { share, maxShare, minContribution, maxSlots, claimedSlots, purchase } = this.props

    const props = {
      maxSlots,
      share,
      allowedShareAmount: share,
      minContribution: minContribution,
      currencyCode: purchase.currencyCode
    };

    if (this.showingSpecifiedPerPerson()) {
      return (
        <ShareInfoSPP
          {...props}
          onChange={share => this.onSlotsChange(1, share)}
        />
      );
    }

    if (this.showingShareInfoLocked()) {
      return (
        <ShareInfoLocked
          slotsClaimed={claimedSlots}
          maxAmount={maxShare}
          purchase={purchase}
        />
      );
    }

    if (this.showingEvenSplitLocked()) return <ShareInfoEvenSplitLocked share={maxShare} />;

    return (
      <ShareInfoNumberOfSlots
        {...props}
        purchase={purchase}
        onChange={this.onSlotsChange}
      />
    );
  }
}

ShareInfoContainer.defaultProps = {
  onChange: () => { },
};

const mapStateToProps = (state, ownProps) => {
  const { memberships, purchases, ui } = state;
  const currentMembershipId = memberships.current;
  const projectedMembership = get(state.projections,
    `${COMMIT_NAMESPACE}.memberships.${currentMembershipId}`);
  const purchase = purchases.byId[purchases.current];
  const defaultMembership = { shareAmount: Money.zero(purchase.currencyCode) };
  const memberConsumerFieldSchemas = getMemberConsumerFieldSchemas(state);

  const editing = memberConsumerFieldSchemas.length ?
    ownProps.editing : (ownProps.editing || ui.commitFormVersion === DASHBOARD_COMMIT);

  return {
    purchase,
    currentMembershipId,
    currentMembership: getCurrentUserMembership(state),
    editing,
    share: (projectedMembership || defaultMembership).shareAmount,
    maxShare: (projectedMembership || defaultMembership).maxShareAmount,
    memberConsumerFieldSchemas: getMemberConsumerFieldSchemas(state),
    minContribution: purchase.group.minContribution,
    maxSlots: purchase.productOrGroupMaxSlots,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      projectPurchase,
    }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareInfoContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/commit-form/share-info.container.js